/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import Button from "../../../../components/Button";
import Modal, { ModalHeader } from "../../../../components/Modal";
import { ControlTable } from "../../../../components/Table";


const SalaryHistoryCodeInfo = ({ open, setOpen, list }) => {
  const [fields] = useState([
    { title: "매칭여부", key: "isMatching" },
    { title: "직원명", key: "name" },
    { title: "직원코드", key: "code" },
    { title: "재직여부", key: "office" },
    { title: "주민(외국인)번호", key: "jumin" },
  ]);
  
  const cancel = () => {
    setOpen(false);
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="select-client-info">
        <ModalHeader>엑셀 업로드 결과</ModalHeader>
        <ControlTable
          //isLoading={isLoading}
          fields={fields}
          list={list}
          //submit={handleSubmit}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            //size="lg"
            label="닫기"
            color="gray-line"
            action={cancel}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SalaryHistoryCodeInfo;
